<!--
Author: Lsc
Date: 2019-12-19
Desc: 补券信息查询组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-etf-qry bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/fund' }">
                    基金交易
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <div class="statement-content">
            <el-row class="statement-filter">
                <el-col :span="24">
                    <el-button
                        type="yellow"
                        class="print-btn right"
                        v-on:click.prevent="getEtfInfo"
                    >
                        查询
                    </el-button>
                    <div class="right">
                        <date-picker :date="dateSet" v-on:date-get="dateInterval" />
                    </div>
                    <span class="right date-text">
                        选择日期区间：
                    </span>
                    <!-- <el-select v-model="qryArea.fundcode" filterable placeholder="请选择基金" class="fund-filter right">
                        <el-option
                            v-for="item in fundList"
                            :key="item.fundcode"
                            :label="item.fundname"
                            :value="item.fundcode"
                        />
                    </el-select>
                    <span class="right filter-text">
                        选择基金：
                    </span> -->
                    <el-input
                        v-model.trim="qryArea.applydealno"
                        placeholder="请输入申请编号"
                        :maxlength="64"
                        class="fund-filter right"
                    />
                    <span class="right filter-text">
                        申请编号：
                    </span>
                </el-col>
            </el-row>
            <el-table
                :data="etfInfo[0] || []"
                border
                style="width: 100%"
            >
                <el-table-column
                    label="成分股信息"
                >
                    <el-table-column
                        prop="stockcode"
                        label="证券代码"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="stockname"
                        label="证券简称"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="applydealno"
                        label="申请成交编号"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="totalamount"
                        label="应补总数量"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="leftamount"
                        label="未补数量"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="etfamount"
                        label="申请篮子数"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="dealstatus"
                        label="补券状态"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="补券日期"
                        align="center"
                    >
                    </el-table-column>
                </el-table-column>
            </el-table>
            <el-table
                :data="etfInfo[1] || []"
                border
                style="width: 100%"
            >
                <el-table-column
                    label="成分股信息"
                >
                    <el-table-column
                        prop="applydate"
                        label="申请日期"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="businflag"
                        label="申赎方向"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="etfamount"
                        label="申请篮子数"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="cost"
                        label="补券成本"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="totalfee"
                        label="补券费用"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="dealstatus"
                        label="补券状态"
                        align="center"
                    >
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import format from "date-fns/format";
import datePicker from "@/components/form/datePicker";
export default {
    name: "Etflist",
    components: {
        datePicker
    },
    mixins: [mixin],
    data () {
        return {
            qryArea: {
                fundcode: "",
                begindate: "",
                enddate: "",
                applydealno: ""
            },
            dateArr: [],
            pickerOptions: {
                disabledDate: time => {
                    return time.getTime() > new Date().getTime();
                }
            },
            dateSet: { type: "2", min: "1990-01-01", size: "media",val: [] },
            etfInfo: [[], []],
            fundList: []
        };
    },
    mounted () {
        this.dateSet.max = this.$util.fmtDate(format(new Date(), "YYYYMMDD"));
        this.qryArea.begindate = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 1);
        this.qryArea.enddate = format(new Date(), "YYYYMMDD");
        const _x = this.$util.fmtDate(this.qryArea.begindate);
        const _y = this.$util.fmtDate(this.qryArea.enddate);
        this.dateSet.val = [_x,_y];
        this.getEtfInfo();
    },
    created () {
        const _this = this;
        this.$util.request("trade/fund/list", {}, "GET", false).then(res => {
            if (res.data) {
                _this.fundList = res.data[0];
            }
        });
        this.qryArea.fundcode = this.fundCode;
    },
    methods: {
        // 获取用户选中时间区间
        dateInterval (val) {
            this.qryArea.begindate = this.$util.isEmpty(val.beginDate) ? "" : val.beginDate.replace(/-/g, "");
            this.qryArea.enddate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },
        getEtfInfo () {
            const _this = this;
            if(this.$util.isEmpty(this.qryArea.begindate) || this.$util.isEmpty(this.qryArea.enddate)){
                let _m = "请输入完整的日期范围";
                this.$alert(_m,"日期提示");
                return;
            }
            this.$util.request("etf/voucher/qry", {"begindate": _this.qryArea.begindate, "enddate": _this.qryArea.enddate, "applydealno": _this.qryArea.applydealno}, "GET", false).then(res => {
                if (res.data) {
                    _this.etfInfo = res.data;
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-etf-qry {
    padding-bottom: 50px;
    .date-text{line-height: 40px;margin-right: 10px;}
    .filter-text{line-height: 40px;margin-right: 10px;}
    .statement-content {
        padding: 0px 20px;
        .base-form-info {
            overflow: hidden;
            margin: 10px auto;
            width: 100%;
            border-top: 1px solid #EBEEF5;
            border-left: 1px solid #EBEEF5;
            box-sizing: border-box;
            -moz-box-sizing: border-box;
            -webkit-box-sizing: border-box;
            .el-col {
                padding: 12px 0px;
                border-right: 1px solid #EBEEF5;
                border-bottom: 1px solid #EBEEF5;
                line-height: 23px;
                text-align: center;
                &.hd {
                    background: #F5F7FA;
                    color: #909399;
                    font-weight: 1000;
                    text-indent: 10px;
                    text-align: left;
                }
                &.no-data {
                    font-size: 14px;
                    padding: 18px 0px;
                    color: #909399;
                }
            }
        }
        .statement-filter {
            text-align: right;
            padding: 10px 0px;
            .print-btn {
                margin-left: 10px;
            }
            .fund-filter {
                width: 400px;
                margin-right: 10px;
            }
        }
        .table-title {
            padding: 10px 0px;
        }
    }
}
</style>
